export default __webpack_public_path__ + "static/media/enLogo.75f93043.png";